import React, { useState, useRef } from "react";
import { createForm, readFile } from "./fileReader";
import LoadingRing from "./LoadingRing";
import { plusIcon, userIcon } from "../../../../../Base/SVG";
import { uploadProfileImage } from "../../../../../redux/profile/api";
import useWallet from "../../../../../utils/hooks/useWalletConnect";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import useSignature from "../../../../../utils/hooks/useSignature";
const fetchingStates = {
  idle: "STATE_IDLE",
  error: "STATE_ERROR",
  fetching: "STATE_FETCHING",
  success: "STATE_SUCCESS",
};

const ChooseImage = ({
  addClass = "",
  active,
  imageData,
  updateForm,
  fetchProfileData,
  isSignIn,
  isConnected,
}) => {
  const { account } = useWallet();
  const { signature, nonce } = useSelector(({ user }) => user);
  const {getAuth } = useSignature();

  const fileRef = useRef();
  const [status, setStatus] = useState(fetchingStates.idle);

  const previewImage = async () => {
    if (fileRef.current.files && fileRef.current.files[0]) {
      const image = fileRef.current.files[0];
      // const $auth = {
      //   address: account,
      //   signature: signature,
      //   nonce: nonce,
      //   networkId: "BSC",
      // };
      const $auth = getAuth;
      setStatus(fetchingStates.fetching);
      // const res = await uploadProfileImage(image, $auth);
      await toast.promise(uploadProfileImage(image, $auth), {
        pending: "Uploading image...",
        success: "Image uploaded successfully!",
        error: "Failed to upload image!",
      });
      fetchProfileData();
      setStatus(fetchingStates.success);
    }
  };
  const onLoad = (resultImage) => {
    updateForm({
      avatar: resultImage,
    });
  };

  const deleteFunc = () => {
    updateForm({ avatar: "" });
    setStatus(fetchingStates.idle);
  };

  return (
    <div className={`upload ${active ? "active" : ""}`}>
      <div className="avatar">
        {status === fetchingStates.fetching ? (
          <LoadingRing size={20} color={"#ff9b63"} />
        ) : imageData ? (
          <img src={imageData} alt=" image" />
        ) : (
          <span className="icon">{userIcon}</span>
        )}
      </div>
      {isSignIn && isConnected && (
        <div className="upload__btns">
          <button className="button primary">
            <input
              type="file"
              onChange={previewImage}
              ref={fileRef}
              accept="image/*"
            />
            {plusIcon}
            Upload new picture
          </button>
          {imageData && (
            <button className="button bordered" onClick={deleteFunc}>
              Remove
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ChooseImage;
